import { render, staticRenderFns } from "./Angels.vue?vue&type=template&id=2e8313a9&"
import script from "./Angels.vue?vue&type=script&lang=js&"
export * from "./Angels.vue?vue&type=script&lang=js&"
import style0 from "./Angels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports